export default function With() {
  return (<svg xmlns="http://www.w3.org/2000/svg" width="10.637" height="10.622" viewBox="0 0 10.637 10.622">
    <path id="Path_21404" data-name="Path 21404" d="M9.878,36.534,6.13,32.249c-.262-.3-.711-.088-.711.337v1.907A5.824,5.824,0,0,0,.263,39.105,8.481,8.481,0,0,0,0,41.495c0,.092,0,.118,0,.137a.411.411,0,0,0,.774.244,7.133,7.133,0,0,1,1.568-2.089,3.915,3.915,0,0,1,3.071-1.079v2.448c0,.424.449.637.711.337l3.748-4.285A.526.526,0,0,0,9.878,36.534Z" transform="translate(0.3 -31.797)" fill="none" stroke="#8e8e8e" strokeWidth="0.6" />
  </svg>)
}

